import React, { KeyboardEvent, useState } from 'react';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import Downshift from 'downshift';
import { WrappedFieldInputProps } from 'redux-form';

import { DeleteIcon } from './DeleteIcon';

/**
 * This is component is intentionally styled like Antd Select.
 * Some day all of this has to be refactored...
 */
export const FormTagsInput = ({
  input: { onChange, value: _value },
}: {
  input: WrappedFieldInputProps;
}): JSX.Element => {
  const value: string[] = _value || [];
  const [inputValue, setInputValue] = useState('');

  const commitItem = (_newItem: string): void => {
    const newItem = _newItem.trim();
    if (value.includes(newItem)) {
      setInputValue('');
      return;
    }
    const clonedValue = [...value];

    if (!newItem.replace(/\s/g, '').length) {
      return;
    }

    clonedValue.push(newItem.trim());
    onChange(clonedValue);
    setInputValue('');
  };

  return (
    <>
      <Downshift
        inputValue={inputValue}
        onChange={(item: string[] | null): void => {
          let clonedValue = [...value];
          if (!clonedValue.includes(item)) {
            clonedValue = [...clonedValue, item];
          }
          setInputValue('');
          onChange(clonedValue);
        }}
        value={value}
      >
        {({ getInputProps }) => {
          const {
            onBlur,
            onChange: onChangeDownshift,
            onFocus,
            ...inputProps
          } = getInputProps({
            onKeyDown: (event: KeyboardEvent<any>) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                event.stopPropagation();
                commitItem(event?.target?.value);
              }
              if (value.length && !inputValue.length && event.key === 'Backspace') {
                onChange(value.slice(0, value.length - 1));
              }
            },
          });
          return (
            <div>
              <TextField
                InputProps={{
                  style: { flexWrap: 'wrap' },
                  inputProps: {
                    style: {
                      width: 'auto',
                    },
                  },
                  startAdornment: value.map((item: string) => (
                    <Chip
                      key={item}
                      tabIndex={-1}
                      label={item}
                      onDelete={() => {
                        const clonedValue = [...value];
                        clonedValue.splice(clonedValue.indexOf(item), 1);
                        onChange(clonedValue);
                      }}
                      deleteIcon={<DeleteIcon />}
                      style={{
                        backgroundColor: '#f5f5f5',
                        borderRadius: 2,
                        fontSize: 14,
                        borderColor: 'rgb(240, 240, 240)',
                        borderWidth: 1,
                        borderStyle: 'solid',
                        height: 24,
                        marginBottom: 2,
                        marginRight: 4,
                      }}
                    />
                  )),
                  onBlur: (event): void => {
                    commitItem(inputValue);
                    onBlur(event);
                  },
                  onChange: (event): void => {
                    setInputValue(event.target.value);
                    onChangeDownshift(event);
                  },
                  onFocus,
                }}
                {...inputProps}
              />
            </div>
          );
        }}
      </Downshift>
    </>
  );
};
